/* global __webpack_public_path__ */

if (typeof window !== 'undefined' && typeof window.__WUJIE_PUBLIC_PATH__ === 'string') {
	// eslint-disable-next-line no-global-assign
	__webpack_public_path__ = window.__WUJIE_PUBLIC_PATH__;
}
